import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "./style.scss";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export interface ImageCarouselProps {
  images: string[];
  className?: string;
  autoplay?: boolean;
  autoplayDelay?: number;
  showPagination?: boolean;
  loop?: boolean;
  pauseOnMouseEnter?: boolean;
  disableOnInteraction?: boolean;
  altPrefix?: string;
  style?: React.CSSProperties;
  borderRadius?: number;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  images,
  className = "offer-preview-swiper",
  autoplay = false,
  autoplayDelay = 2500,
  showPagination = false,
  loop = true,
  pauseOnMouseEnter = true,
  disableOnInteraction = true,
  altPrefix = "image",
  style = { width: "100%", height: "auto" },
  borderRadius = 0,
}) => {
  if (!images || images.length === 0) {
    return null;
  }

  if (images.length === 1) {
    return (
      <img
        src={images[0]}
        alt={`${altPrefix} 1`}
        className={className}
        style={{ borderRadius: `${borderRadius}px`, ...style }}
      />
    );
  }

  const modules = [Pagination];
  if (autoplay) {
    modules.push(Autoplay);
  }

  const stopLabelToggle = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div
      className="image-carousel-wrap"
      style={style}
      onClick={stopLabelToggle}
      onPointerDown={(event) => event.stopPropagation()}
    >
      <Swiper
        modules={modules}
        className={className}
        nested={true}
        slidesPerView={1}
        spaceBetween={0}
        observer={true}
        observeParents={true}
        watchOverflow={true}
        resistanceRatio={0}
        loop={loop && images.length > 2}
        autoplay={
          autoplay
            ? {
                delay: autoplayDelay,
                disableOnInteraction,
                pauseOnMouseEnter,
              }
            : false
        }
        pagination={
          showPagination
            ? {
                clickable: true,
              }
            : false
        }
        style={{ position: "relative", padding: 0, margin: 0 }}
      >
        {images.map((image, index) => (
          <SwiperSlide
            key={`${image}-${index}`}
            className="swiper-slide-visible"
            style={{ margin: 0 }}
          >
            <img
              src={image}
              alt={`${altPrefix} ${index + 1}`}
              style={{ borderRadius: `${borderRadius}px` }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageCarousel;
